import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`leftTotalMenu ofs posFi `)
}
const _hoisted_3 = { class: "mt20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs14 ml10 fl" }, "設定メニュー", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "mt10" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "fs15 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0","color":"#064984"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs15 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0","color":"#064984"}
}, "スグINボタン", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "w90 mc",
  style: {"height":"2px","background":"#a9bed2"}
}, " ", -1)
const _hoisted_16 = { class: "mt20" }
const _hoisted_17 = {
  key: 0,
  class: "pad5"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs15" }, "調整カレンダーを編集", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "mt10"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  class: "fs15 ml15 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0","color":"#064984"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs12 ml15 fw600 fl mt10",
  style: {"margin-bottom":"0","color":"#064984"}
}, [
  /*#__PURE__*/_createTextVNode(" 会議室などの"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("サブ調整カレンダーを設定 ")
], -1)
const _hoisted_27 = {
  key: 0,
  class: "fr"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 2,
  class: "mt10"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "w90 mc",
  style: {"height":"2px","background":"#a9bed2"}
}, " ", -1)
const _hoisted_32 = { class: "mt20" }
const _hoisted_33 = { class: "mt10" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  class: "fs15 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0","color":"#064984"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return ([`room`, `public_settings`, `parent_settings`, `form`, `mail`].includes(_ctx.selectedTabName))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_IconHelp, {
              width: 34,
              class: "fr mr10",
              tooltipText: `使い方ヘルプページ`,
              style: {"margin-top":"-11px"},
              onClick: _ctx.goHelpCenter
            }, null, 8, ["onClick"]),
            _hoisted_5,
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttonArray, (buttonDic, buttonIndex) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${buttonDic.name}${buttonIndex}`,
                  onClick: ($event: any) => (_ctx.clickLi(buttonDic)),
                  class: "pointer hoverLgreyBg",
                  style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(buttonDic.image_url),
                    class: "fl ml20 mt18",
                    width: "14",
                    height: "14"
                  }, null, 8, _hoisted_8),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(buttonDic.name), 1),
                  _hoisted_10
                ], 8, _hoisted_7))
              }), 128)),
              (_ctx.rcm.room_setting && _ctx.rcm.room_setting.is_instant_room)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "pointer hoverLgreyBg",
                    style: {"height":"50px","line-height":"50px","border":"1px solid #eee"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickInstantRoomTextSetting && _ctx.clickInstantRoomTextSetting(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/field_text_head.png`),
                      class: "fl ml20 mt18",
                      width: "14",
                      height: "14"
                    }, null, 8, _hoisted_11),
                    _hoisted_12,
                    _hoisted_13
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_14
          ]),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_ctx.rcm.astag)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (!_ctx.rcm.room.is_shared_chukai)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "centered pad5 rad10 with_white_bg mt10 pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickEditAstag({ editType: `editAstag` })))
                      }, [
                        _createVNode(_component_CalendarIcon, {
                          astag: _ctx.rcm.astag,
                          width: 200,
                          iconWidth: 50,
                          totalHeight: 40,
                          canDelete: false,
                          hideName: true,
                          hideBorder: true,
                          showSharedInfo: true,
                          classes: `mt3 mc`
                        }, null, 8, ["astag"]),
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20
                      ])), [
                        [_directive_tooltip, `${_ctx.rcm.astag.name}の\n調整カレンダーを利用しています`]
                      ])
                    : _createCommentVNode("", true),
                  _hoisted_21
                ]))
              : _createCommentVNode("", true),
            (_ctx.rcm.room && _ctx.rcm.room.is_owner)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarsArray, (buttonDic, buttonIndex) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${buttonDic.name}${buttonIndex}`,
                      onClick: ($event: any) => (_ctx.clickEditAstag(buttonDic)),
                      class: "pointer hoverLgreyBg",
                      style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
                    }, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(buttonDic.name), 1),
                      _hoisted_25
                    ], 8, _hoisted_23))
                  }), 128)),
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickEditAstag({ editType: `subAstag` }))),
                    class: "pointer hoverLgreyBg",
                    style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
                  }, [
                    _hoisted_26,
                    (!_ctx.rm.canUseOption(`room_sub_astag`, false))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_IconLock, {
                            style: {"margin-top":"15px","margin-right":"15px"},
                            class: "fr",
                            width: 16
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_28
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, " ")),
            _hoisted_30
          ]),
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("ul", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherSettingsArray, (buttonDic, buttonIndex) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${buttonDic.name}${buttonIndex}`,
                  onClick: ($event: any) => (_ctx.clickSettingsLi(buttonDic)),
                  class: "pointer hoverLgreyBg",
                  style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(buttonDic.image_url),
                    class: "fl ml20 mt18",
                    width: "14",
                    height: "14"
                  }, null, 8, _hoisted_35),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(buttonDic.name), 1),
                  _hoisted_37
                ], 8, _hoisted_34))
              }), 128))
            ]),
            _hoisted_38
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}